export default "__VITE_ASSET__vvZX7rbo__"